import { Pipe, PipeTransform } from '@angular/core';
import { User } from 'src/app/models/user.model';

@Pipe({
  name: 'remoteWorkDays',
  standalone: true,
})
export class RemoteWorkDaysPipe implements PipeTransform {
  transform(user: User): string {
    const current_working_contract_weekly_schedule = user.current_working_contract?.current_working_contract_weekly_schedule;

    if (current_working_contract_weekly_schedule == null) {
      return '-';
    }

    const daysMap: { [key: string]: boolean } = {
      Lunes: current_working_contract_weekly_schedule.has_remote_work_monday,
      Martes: current_working_contract_weekly_schedule.has_remote_work_tuesday,
      Miércoles: current_working_contract_weekly_schedule.has_remote_work_wednesday,
      Jueves: current_working_contract_weekly_schedule.has_remote_work_thursday,
      Viernes: current_working_contract_weekly_schedule.has_remote_work_friday,
      Sábado: current_working_contract_weekly_schedule.has_remote_work_saturday,
      Domingo: current_working_contract_weekly_schedule.has_remote_work_sunday,
    };

    const remoteDays = Object.keys(daysMap).filter((day: string): boolean => daysMap[day]);

    if (remoteDays.length === 0) {
      return 'Ninguno';
    }

    return remoteDays.join(', ');
  }
}
